import { CreateNotSQNPIDTO, filtersDTO, NotSQNPIDTO, NotSQNPIDTOResponse, UpdateNotSQNPIDTO } from "./dto";
import { NotificationSQNPIServiceImpl } from "./serviceImpl";

export interface NotificationSQNPIService {
    GetAllNotificationSQNPI(filters: filtersDTO): Promise<NotSQNPIDTOResponse>
    UpdateNotSQNPI(body: UpdateNotSQNPIDTO, id: string): Promise<void>
    CreateNotSQNPI(data: CreateNotSQNPIDTO): Promise<void>
}

export function NewNotificationSQNPIService(): NotificationSQNPIService {
    return new NotificationSQNPIServiceImpl()
}